import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Popup, Icon } from 'semantic-ui-react';
import Svg from 'react-inlinesvg';
import { infoIcon } from '../../../images';

const StyledIcon = styled(Icon)`
  margin: 0 0.5rem !important;
  visibility: hidden;
  position: relative;
  top: 0.1875rem;
  svg {
    height: 20px;
    width: 20px;
  }
`;

const FormatCell = ({ cell }) => {
  const getContent = format => {
    switch (format) {
      case '.eps':
        return 'A raw file format that can be opened and modified in Adobe Illustrator or Photoshop.';
      case '.png':
        return 'A larger image format that includes a transparent background.';
      case '.jpg':
        return "The most common image format that doesn't include a transparent background.";
      case '.pdf':
        return 'File format that includes text and multiple graphic elements that cannot be edited.';
      default:
      // code block
    }
  };

  return (
    <div>
      {cell.value}
      <Popup
        trigger={
          <StyledIcon className="table__item--hidden">
            <Svg src={infoIcon} />
          </StyledIcon>
        }
        header={`What is ${cell.value}?`}
        content={getContent(cell.value)}
        position="bottom left"
      />
    </div>
  );
};

FormatCell.propTypes = {
  cell: PropTypes.object.isRequired
};
export default FormatCell;
